import useApi from "@/hooks/useApi";
import React, { useState } from "react";
import IntegrationActivityLog from "../IntegrationActivityLog";
import Panel from "@/components/Panel";
import { IconTrash } from "@velaro/velaro-component-lib";
import FormstackModal from "./FormstackModal";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { IconClose } from "@velaro/velaro-component-lib";
import { AlertTriangle } from "@velaro/velaro-component-lib";
import {
  Modal,
  ModalBody,
} from "@velaro/velaro-component-lib";
import { da } from "date-fns/locale";

interface FormstackConfig {
  displayName: string;
  token: string;
}

export default function Formstack() {
  const [config, setConfig] = React.useState<FormstackConfig>({
    displayName: "",
    token: ""
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const api = useApi();
  const [showRemoveModal, setshowRemoveModal] = useState(false);

  const fetchConfig = React.useCallback(async () => {
    const response = await api.messaging.get(`Formstack/Integrations/GetConfig`);
    
    if (response.ok) {
      const text = await response.text();
      if (text) {
        const data = JSON.parse(text);
        setConfig(data);
      } else {
        setConfig({ displayName: "", token: "" });
      }
    } else {
      setConfig({ displayName: "", token: "" });
    }
  }, [api.messaging]);
  

  React.useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  async function handleSubmit(config: FormstackConfig) {
    const response = await api.messaging.post(
      "Formstack/Integrations/SaveConfig",
      {
        displayName: config.displayName,
        token: config.token
      }
    );
    if (response.ok) {
      setConfig(config);
    }
    setShowEditModal(false);
    setShowAddModal(false);
  }

  function handleModalClose() {
    setShowAddModal(false);
    setShowEditModal(false);
  }

  const deleteConfig = React.useCallback(async () => {
    if (confirm("are you sure you want to delete this integration?")) {
      await api.messaging.delete(`Formstack/Integrations/DeleteConfig`);
      setConfig({ displayName: "", token: "" });
    }
  }, [api.messaging]);

  const confirmDelete = async (id?: number) => {
    await api.messaging.delete(`Formstack/Integrations/DeleteConfig`);
    setConfig({ displayName: "", token: "" });
    setshowRemoveModal(false);
  };

  return (
    <div>
      <div className="panel bg-white dark:bg-stone-300 rounded-2xl shadow-md mb-4 p-6">
        <table className="table-fixed w-full p-4">
          <thead>
            <tr>
              <th className="w-1/2 text-slate-800 text-lg font-medium leading-7 text-left">
                Formstack Configuration
              </th>
              <th className="w-1/2 text-right">
                {config.displayName == "" && config.token == "" && (
                  <PrimaryBlueButton
                    label="Add New Formstack Configuration"
                    onClick={() => setShowAddModal(true)}
                    className="w-auto  h-full"
                  />
                  // <button
                  //   type="submit"
                  //   className="btn-green mt-4"
                  //   onClick={() => setShowAddModal(true)}
                  // >
                  //   Add New Formstack Configuration
                  // </button>
                )}
                {config.displayName != "" && config.token != "" && (
                  <PrimaryBlueButton
                    label="Edit Formstack Configuration"
                    onClick={() => setShowEditModal(true)}
                    className="w-auto  h-full"
                  />
                  // <button
                  //   type="submit"
                  //   className="btn-green mt-4"
                  //   onClick={() => setShowEditModal(true)}
                  // >
                  //   Edit Formstack Configuration
                  // </button>
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="w-1/2 text-slate-800 text-sm font-medium text-left pr-6">
                Display Name
              </td>
              <td className="w-1/2 text-slate-800 text-sm font-medium text-left">
                Formstack Access Token
              </td>
              <td className="w-48"></td>
            </tr>
            <tr>
              <td className="pr-6 w-full">
                <input
                  type="text"
                  value={config.displayName}
                  className="w-full px-3 py-2 border rounded-lg"
                  disabled
                />
              </td>
              <td className=" w-full flex gap-5 items-center">
                <input
                  type="text"
                  value={config.token}
                  className="w-full px-3 py-2 border rounded-lg text-slate-800 text-sm font-normal"
                  disabled
                />
                <div className="cursor-pointer" onClick={() => setshowRemoveModal(true)}>
                  <IconTrash />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {showEditModal && !showAddModal && (
        <FormstackModal
          config={config}
          modalType="edit"
          handleSubmit={handleSubmit}
          handleModalClose={() => handleModalClose()}
        />
      )}
      {showAddModal && !showEditModal && (
        <FormstackModal
          config={config}
          modalType="add"
          handleSubmit={handleSubmit}
          handleModalClose={() => handleModalClose()}
        />
      )}

      {showRemoveModal && (
        <Modal show={showRemoveModal}>
          <ModalBody>
            <div className="flex items-center mb-6 justify-between">
              <div className="flex items-center gap-2">
                <AlertTriangle className="w-8  text-[#EE3763]" />
                <div className="text-slate-800 text-xl font-medium">
                  Remove Account
                </div>
              </div>
              <button onClick={() => setshowRemoveModal(false)}>
                <IconClose className="w-8 text-slate-500" />
              </button>
            </div>

            <div className="text-center text-slate-800 text-sm font-normal">
              Are you sure you want to remove the account{" "}
              {config?.displayName}? This action cannot be undone.
            </div>
            <div className="pt-6 flex justify-center gap-4">
              <button
                onClick={() => setshowRemoveModal(false)}
                className="rounded-lg px-6 py-2 bg-white border border-primary hover:border-primary-hover text-[#1670e7] text-sm font-medium"
              >
                Cancel
              </button>
              <button
                onClick={() => confirmDelete()}
                className="rounded-lg px-6 py-2 bg-primary border border-primary hover:bg-primary-hover hover:border-primary-hover text-white text-sm font-medium"
              >
                Remove
              </button>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Activity Log */}
      <div className="mt-8">
        <h2 className="text-sm font-semibold text-slate-700 mb-3">Activity Log</h2>
        <IntegrationActivityLog integrationSlug="Formstack" />
      </div>
    </div>
  );
}
